<template>
  <div class="container banner-layout" :style="containerHeight">
    <div
      class="banner-wrapper"
      :style="bgStyle"
    >
      <div class="version-info-wrapper">
        <version-info></version-info>
      </div>
    </div>
    <div class="content-wrapper">
      <div class="system-info" v-if="info.identifyType === '0'">
        <img
          class="logo"
          :src="logoPath"
          v-if="info.loginLogoInfo"
          :style="iconImgStyle"
        />
        <span class="title">{{ info.systemName }}</span>
      </div>
      <div class="system-info" v-else>
        <img
          class="logo"
          :src="info.identifyImgInfo.path"
          :style="identifyImgInfoStyle"
        >
      </div>

      <div
        class="bgimg-wrapper"
        v-if="info.cImgType==='0'"
      >
        <div
          class="inner"
          v-show="info.imageMode === 'center'"
          :style="imageStyle"
        ></div>
        <div class="form-wrapper">
          <slot></slot>
        </div>
      </div>
      <div
        class="bgimg-wrapper"
        v-else
      >
        <lottie
          :options="defaultOptions"
          :dateTime="dateTime"
        ></lottie>
        <div class="form-wrapper">
          <slot></slot>
        </div>
      </div>
      <div class="select-wrapper">
        <el-button
          type="iconButton"
          icon="h-icon-download"
          class="down-btn"
          :style="downloadTextColor"
          @click="openDownLoad"
        >
          {{ $t("login.download_text") }}
        </el-button>
        <slot name="lang-select"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import versionInfo from './version-info.vue'
import lottie from 'components/lottie/lottie'
import axios from 'axios'
export default {
  name: 'banner-layout',
  props: {
    info: {
      type: Object,
      default: () => {
        return {
          backgroundImgInfo: {
            path: ''
          },
          bgColor: '',
          bgImgType: '1',
          cImgType: '0',
          ctImgInfo: {
            path: ''
          },
          ctZipInfo: {
            path: ''
          },
          identifyImgInfo:{
            path: ''
          },
          identifyType:'0',
        }
      }
    }
  },
  data () {
    return {
      defaultOptions: {},
      dateTime: new Date().getTime()
    }
  },
  computed: {
    downloadTextColor () {
      return {
        'color': `${this.info.downloadTextColor || '#4d4d4d'}`
      }
    },
    bgStyle () {
      let _res = {}
      if (this.info.bgImgType === '0') {
        _res['background-image'] = `url(${this.info.backgroundImgInfo.path})`
        _res['background-size'] = 'cover'
      } else {
        _res['background-color'] = this.info.bgColor
      }
      return _res
    },
    containerHeight(){
      const _res = {}
      if(!this.info.recordNumber){
        _res['height'] = '100%'
      }
      return _res
    },
    systemNameStyle () {
      return {
        'color': `${this.info.systemNameColor || '#fff'}`
      }
    },
    imageStyle () {
      return {
        'background-image': `url(${this.info.ctImgInfo.path})`
      }
    },
    iconImgStyle () {
      const _iconImg = this.info.loginLogoInfo
      if (!_iconImg) return {}
      const _height = parseInt(_iconImg.height) < 32 ? _iconImg.height : 32
      return {
        height: `${_height}px`
      }
    },
    identifyImgInfoStyle(){
      const _identifyImgInfo = this.info.identifyImgInfo.path
      if (!_identifyImgInfo) return {}
      const _height = parseInt(_identifyImgInfo.height) < 61 ? _identifyImgInfo.height : 60
      return {
        height: `${_height}px`
      }
    },
    logoPath () {
      return this.info.loginLogoInfo ? this.info.loginLogoInfo.path : ''
    }
  },
  mounted () {
    this.getAnimatJson()
  },
  methods: {
    openDownLoad () {
      this.$emit('open-download')
    },
    async getAnimatJson () {
      if (this.info.ctZipId !== '-1' && this.info.cImgType) {
        const requestUrl = this.info.ctZipInfo.path
        const animatJson = await axios.get(requestUrl)
        for (let i = 0; i < animatJson.data.assets.length; i++) {
          if (animatJson.data.assets[i].u) {
            animatJson.data.assets[i].u = `${process.env.VUE_APP_BASEURL}/zip/dynamicDisplay/${this.info.ctZipId}/images/`
          } else {
            break
          }
        }
        this.dateTime = new Date().getTime()
        this.defaultOptions = { animationData: animatJson.data }
      }
    }
  },
  components: {
    versionInfo,
    lottie
  },
  watch: {
    info: {
      handler () {
        this.getAnimatJson()
      },
      deep: true
    }
  }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
.banner-layout.container {
  width: 100%;
  height: calc(~"100% - 30px");
  position: relative;
  .banner-wrapper {
    height: 480px;
    width: 100%;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
    .version-info-wrapper {
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }
  .content-wrapper {
    width: 1280px;
    height: 480px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    z-index: 2;
    .system-info {
      height: 32px;
      position: absolute;
      left: 24px;
      top: -46px;
      .title {
        display: inline-block;
        vertical-align: middle;
        white-space: pre;
      }
      .logo {
        display: inline-block;
        vertical-align: middle;
        width: auto;
      }
    }
    .copyright-wrapper {
      position: absolute;
      bottom: -40px;
      left: 50%;
      transform: translateX(-50%);
      height: 16px;
      .name {
        text-decoration: none;
        display: inline-block;
        vertical-align: middle;
      }
      .logo {
        display: inline-block;
        vertical-align: middle;
        margin-right: 6px;
      }
    }
    .bgimg-wrapper {
      width: 736px;
      height: 448px;
      position: absolute;
      left: 88px;
      top: 18px;
      .inner {
        width: 100%;
        height: 100%;
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
      }
      .form-wrapper {
        width: 312px;
        // padding-bottom: 20px;
        position: absolute;
        right: -328px;
        top: 10px;
        box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.08),
          0 8px 12px 0 rgba(0, 0, 0, 0.12);
      }
    }

    .select-wrapper {
      position: absolute;
      right: 24px;
      top: -46px;
      display:flex;
      align-content: center;
      .down-btn {
        vertical-align: middle;
        font-weight: normal;
        background: none;
        opacity: 0.6;
        border: 1px solid rgba(255,255,255,0.12);
        border-radius: 2px;
        filter: alpha(opacity=60);
        &:hover {
          background: none;
          opacity: 1;
          filter: alpha(opacity=100);
        }
      }
    }
  }
}
</style>
